module.exports = __webpack_public_path__ + "img/finance_analysis_.53cc0154.svg";